import { LoginForm } from "./LoginForm";

export function App(){
    return <section>
        <LoginForm/>
    </section>
}